import { createSvgIcon } from "@mui/material";

export default createSvgIcon(
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      id="Vector"
      d="M17.969 9.122L9.869 1.022C9.53152 0.687272 9.07533 0.499621 8.6 0.500001H2.3C1.82261 0.500001 1.36477 0.689643 1.02721 1.02721C0.689643 1.36477 0.500001 1.82261 0.500001 2.3V8.6C0.499812 8.83752 0.546635 9.07273 0.63777 9.29207C0.728904 9.51141 0.862549 9.71055 1.031 9.878L9.131 17.978C9.46848 18.3127 9.92467 18.5004 10.4 18.5C10.8766 18.498 11.333 18.307 11.669 17.969L17.969 11.669C18.307 11.333 18.498 10.8766 18.5 10.4C18.5002 10.1625 18.4534 9.92727 18.3622 9.70793C18.2711 9.48859 18.1374 9.28945 17.969 9.122ZM10.4 16.7L2.3 8.6V2.3H8.6L16.7 10.4M4.55 3.2C4.817 3.2 5.07801 3.27918 5.30002 3.42752C5.52203 3.57586 5.69506 3.7867 5.79724 4.03338C5.89942 4.28006 5.92615 4.5515 5.87406 4.81337C5.82197 5.07525 5.6934 5.31579 5.50459 5.50459C5.31579 5.6934 5.07525 5.82197 4.81337 5.87406C4.5515 5.92615 4.28006 5.89942 4.03338 5.79724C3.7867 5.69506 3.57586 5.52203 3.42752 5.30002C3.27918 5.07801 3.2 4.817 3.2 4.55C3.2 4.19196 3.34223 3.84858 3.59541 3.59541C3.84858 3.34223 4.19196 3.2 4.55 3.2Z"
      fill="currentColor"
    />
  </svg>,
  "Tag"
);
